import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from '../assets/bdmDashboard.module.css';

const BdmDashboard = () => {
  const navigate = useNavigate();
  const [bdmData, setBdmData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
      const response = await fetch(`${API_BASE_URL}/api/bdm/dashboard`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('BDM Dashboard API Response:', data);
        console.log('BDM Dashboard API Response data:', data.data);
        console.log('BDM Dashboard API Response data.sales:', data.data?.sales);
        setBdmData(data.data);
      } else {
        console.error('Failed to load data');
        toast.error('Failed to load BDM dashboard data');
      }
    } catch (error) {
      console.error('Error loading data:', error);
      toast.error('Error loading BDM dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const handleSalesClick = (salesId) => {
    // Navigate to sales page (matching Laravel's approach)
    window.location.href = `/bdm/sale/${salesId}`;
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumb}>
        <span onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer', color: '#337ab7' }}>Dashboard</span>
        <span className={styles.separator}>/</span>
        <span className={styles.current}>BDM</span>
      </div>

      {/* Client Care Team Widget */}
      <div className={styles.clientCareTeam}>
        <div className={styles.widgetHeader}>
          <h3>Client Care Team</h3>
        </div>
        <div className={styles.widgetContent}>
          <div className={styles.metricRow}>
            <span className={styles.metricLabel}>Sales Ready:</span>
            <span className={styles.metricValue}>0</span>
          </div>
          <div className={styles.metricRow}>
            <span className={styles.metricLabel}>Hot Leads:</span>
            <span className={styles.metricValue}>0</span>
          </div>
          <div className={styles.metricRow}>
            <span className={styles.metricLabel}>Pre:</span>
            <span className={styles.metricValue}>21</span>
          </div>
          <div className={styles.metricRow}>
            <span className={styles.metricLabel}>Under Offer:</span>
            <span className={styles.metricValue}>17</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BdmDashboard; 